export type BingTracking = {
  msclkid: string;
};

export type WithBingTracking = Partial<BingTracking>;

export const BING_TRACKING_KEY = 'msclkid';
